<template>
  <div class="overflow-x-auto w-full max-h-[calc(100dvh-340px)] overflow-y-auto">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <slot></slot>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableComponent"
};
</script>
